import Channels from '../../Containers/Channels/ChannelsContainer';
import ChannelsCreateFormContainer from '../../Containers/Channels/ChannelsCreateFormContainer';
import ChannelsModifyFormContainer from '../../Containers/Channels/ChannelsModifyFormContainer';
import ConnectedBreadcrumbs from '../../Components/Atoms/ConnectedBreadcrumbs';
import Dashboard from '../../Containers/Dashboard';
import Discover from '../../Components/Discover';
import Events from '../../Containers/Events';
import Itinerary from '../../Containers/Schedule/ScheduleContainer';
import MomentDetailsContainer from '../../Containers/Moments/MomentDetailsContainer';
import MomentsGridContainer from '../../Containers/Moments/MomentsContainer';
import Notifications from '../../Components/Notifications/Notifications';
import NotificationsCreateFormContainer from '../../Containers/Notifications/NotificationsCreateFormContainer';
import PageHeading from '../../Components/Atoms/PageHeading';
import PrivateRoute from '../../Containers/PrivateRoute';
import Profile from '../../Containers/Profile/ProfileContainer';
import PromptContainer from '../../Containers/Dashboard/PromptContainer';
import React from 'react';
import Sidebar from '../../Components/Navigation/Sidebar';
import Topbar from '../../Components/Navigation/Topbar';

const Routes = () => (
    <React.Fragment>
        <PrivateRoute component={Events} exact path="/events" />
        <PrivateRoute component={Topbar} path="/events/*" />
        <PrivateRoute component={ConnectedBreadcrumbs} path="/events/*" />
        <PrivateRoute component={PageHeading} path="/events/*" />
        <PrivateRoute component={Sidebar} path="/events/:id" />
        <PrivateRoute component={PromptContainer} path="/events/:id" />
        <PrivateRoute component={Dashboard} exact path="/events/:id" />
        <PrivateRoute component={Discover} exact path="/events/:id/discover" />
        <PrivateRoute component={Profile} exact path="/events/:id/profile" />
        <PrivateRoute component={MomentsGridContainer} exact path="/events/:id/moments" />
        <PrivateRoute component={MomentDetailsContainer} exact path="/events/:id/moments/:moment_id" />

        <PrivateRoute component={Notifications} exact path="/events/:id/notifications" />
        <PrivateRoute component={NotificationsCreateFormContainer} exact path="/events/:id/notifications/new" />

        <PrivateRoute component={Itinerary} exact path="/events/:id/itinerary" />
        <PrivateRoute component={Channels} exact path="/events/:id/channels" />
        <PrivateRoute component={ChannelsCreateFormContainer} exact path="/events/:id/channels/new" />
        <PrivateRoute component={ChannelsModifyFormContainer} exact path="/events/:id/channels/modify" />
    </React.Fragment>
);

export default Routes;
